import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'service-menu',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      // const serviceMenus = document.querySelectorAll( this.selector() );

      // const setupAnimations = () => {
      //   serviceMenus.forEach( ( serviceMenu ) => {
      //     const serviceMenuCardsWrapper = serviceMenu.querySelector( '.service-menu__cards-wrapper' );
      //     const serviceMenuCards = serviceMenu.querySelector( '.service-menu__cards' );

      //     if ( serviceMenu && serviceMenuCardsWrapper && serviceMenuCards ) {
      //       if ( window.innerWidth > 1269 ) {
      //         ScrollTrigger.create( {
      //           trigger: serviceMenu,
      //           start: 'top-=40 top',
      //           end: () => `+=${serviceMenuCards.scrollHeight}`,
      //           pin: true,
      //         } );

      //         gsap.to( serviceMenuCards, {
      //           y: () => -( serviceMenuCards.scrollHeight - ( serviceMenu.offsetHeight / 1.7 ) ),
      //           ease: 'none',
      //           scrollTrigger: {
      //             trigger: serviceMenuCardsWrapper,
      //             start: 'top-=120 top',
      //             end: () => `+=${serviceMenuCards.scrollHeight}`,
      //             scrub: true,
      //           },
      //         } );
      //       }
      //     }
      //   } );
      // };

      // const handleResize = () => {
      //   ScrollTrigger.getAll().forEach( ( trigger ) => trigger.kill() );

      //   if ( window.innerWidth > 1024 ) {
      //     setupAnimations();
      //   }
      // };

      // handleResize();
      // window.addEventListener( 'resize', handleResize );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'service-menu', COMPONENT );
} )( app );
